// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___1zm7P","label":"Editor__label___lfHmg","textarea":"Editor__textarea___1QVlR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Textarea/Editor/Editor.scss
// module id = 994
// module chunks = 0